import { createContext, useContext, useState, useEffect } from "react";
import { translations, defaultLanguage, supportedLanguages } from "./translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage first
    const saved = localStorage.getItem("language");
    if (saved && supportedLanguages.find(l => l.code === saved)) {
      return saved;
    }
    // Check browser language
    const browserLang = navigator.language.split("-")[0];
    if (supportedLanguages.find(l => l.code === browserLang)) {
      return browserLang;
    }
    return defaultLanguage;
  });

  useEffect(() => {
    localStorage.setItem("language", language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const keys = key.split(".");
    let result = translations[language];
    
    for (const k of keys) {
      if (result && result[k] !== undefined) {
        result = result[k];
      } else {
        // Fallback to default language
        result = translations[defaultLanguage];
        for (const fallbackKey of keys) {
          if (result && result[fallbackKey] !== undefined) {
            result = result[fallbackKey];
          } else {
            return key; // Return key if not found
          }
        }
        break;
      }
    }
    
    return result;
  };

  const switchLanguage = (lang) => {
    if (supportedLanguages.find(l => l.code === lang)) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage: switchLanguage, 
      t, 
      supportedLanguages 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
